import { render, staticRenderFns } from "./stack.vue?vue&type=template&id=7f2e3beb"
import script from "./stack.vue?vue&type=script&lang=js"
export * from "./stack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports